import styled from 'styled-components';

const NarrowColumn = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 350px;
`;

export default NarrowColumn;
